import { createContext } from "react";

const HomepageContext = createContext();

export default HomepageContext;
